import { render, staticRenderFns } from "./RomaLayout.vue?vue&type=template&id=841b76ac&scoped=true&"
import script from "./RomaLayout.vue?vue&type=script&lang=js&"
export * from "./RomaLayout.vue?vue&type=script&lang=js&"
import style0 from "./RomaLayout.vue?vue&type=style&index=0&id=841b76ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841b76ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
